import { isLoadingHandler } from '../Utils';

export const TOS_UPDATED = 'TOS_UPDATED';
export const IS_LOADING = 'TOS_IS_LOADING';

const INITIAL_STATE = {
    isLoading: false,
    isUpdated: false,
};

const ACTION_HANDLERS = {
    [IS_LOADING]: isLoadingHandler,
    [TOS_UPDATED]: (state, { payload }) => ({
        ...state,
        isUpdated: payload,
    }),
};

export default (state = INITIAL_STATE, action) => {
    const handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/tos.js